import { responseStatus } from "../constants";
import { ApiPaths } from "../helpers/api";
import { ImportFileLPS } from "../models/luong/Luong";
import { ChiTietKhenThuongNhanSuKhacResponse, DanhSachKhenThuongNhanSuKhacResponse, LuongKhenThuongNhanSuKhacResponse, NhanSuKhac } from "../models/nhansukhac/NhanSuKhac";
import intance from "../utils/axios";

export const layDanhSachNhanSuKhac= async () => {
    var data: Array<NhanSuKhac> = [];
    await intance.get(`${ApiPaths.nhanSuKhac.layDs}`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const luuNhanSuKhac = async (data: any) => {
    await intance.post(ApiPaths.nhanSuKhac.luuNhanSuKhac, data)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const xoaNhanSuKhac = async (id: number) => {
    await intance.post(ApiPaths.nhanSuKhac.xoaNhanSuKhac + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const layMauLuongKhenThuong = async () => {
    var rs: any;
    var request = {
        "thang": 0,
        "nam": 0
    }
    await intance.post(ApiPaths.nhanSuKhac.downloadFileMauLuongKhenThuongNSK, request, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};

export const importFileLuongKhenThuong = async (request: ImportFileLPS) => {
    var rs: Array<LuongKhenThuongNhanSuKhacResponse> = new Array<LuongKhenThuongNhanSuKhacResponse>();
    await intance.post(ApiPaths.nhanSuKhac.uploadFileMauLuongKhenThuongNSK,
        request,
        {
            headers: {
                "Content-Type": "multipart/form-data",
                "Accept": "application/json",
            },
        }
    )
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};

export const luuKhenThuongNhanSuKhac = async (request: any) => {
    var rs = 0;
    await intance.post(ApiPaths.nhanSuKhac.luuKhenThuongNSK, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return rs;
};

export const layDsKhenThuongNhanSuKhac = async (tuKhoa?: string) => {
    var rs: Array<DanhSachKhenThuongNhanSuKhacResponse> = [];
    await intance.get(ApiPaths.nhanSuKhac.layDSKhenThuongNSK + "?tuKhoa=" + tuKhoa).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return rs;
};

export const layChiTietKhenThuongNhanSuKhac = async (id: number) => {
    var rs: ChiTietKhenThuongNhanSuKhacResponse = new ChiTietKhenThuongNhanSuKhacResponse();
    await intance.get(ApiPaths.nhanSuKhac.layChiTietKhenThuongNSK + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return rs;
};

export const xoaLuongKhenThuongNhanSuKhac = async (id: any) => {
    await intance.post(ApiPaths.nhanSuKhac.xoaKhenThuongNSK + "?id=" + id).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
}
